export const MX_PAGE_VIEW_EVENT = 'page_view';
export const MX_PAGE_ACTION_EVENT = 'page_action';
